import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsDefined, IsEmpty, IsEnum, IsObject, IsOptional, IsString, ValidateNested } from 'class-validator';
import { MerchantContractStatusEnum, MerchantExposeGroup, StoreModeEnum, StoreStateEnum } from '../interface';
import { DictionaryDto } from './DictionaryDto';
import { MerchantContactInfoDto } from './MerchantContactInfoDto';
import { MerchantCountryDto } from './MerchantCountryDto';
import { MerchantFeaturesFlagsDto } from './MerchantFeaturesFlagsDto';
import { MerchantMailerDto } from './MerchantMailerDto';
import { MerchantOrderDto } from './MerchantOrderDto';
import { MerchantPlacePickerDto } from './MerchantPlacePickerDto';
let MerchantDto = class MerchantDto {
};
__decorate([
    Expose({ groups: [MerchantExposeGroup.MODEL] }),
    __metadata("design:type", String)
], MerchantDto.prototype, "_id", void 0);
__decorate([
    ApiProperty({ type: () => String, example: '9d3f8f9b-881a-49a7-a79e-ce53399976f7' }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ] }),
    IsEmpty({ always: true }),
    __metadata("design:type", String)
], MerchantDto.prototype, "merchantId", void 0);
__decorate([
    ApiProperty({ type: () => String, example: '84fbef05-41c8-42d9-b4c7-76c7e9b4588f' }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ] }),
    IsEmpty({ always: true }),
    __metadata("design:type", String)
], MerchantDto.prototype, "storeId", void 0);
__decorate([
    ApiProperty({ type: () => String, minLength: 3, maxLength: 50, example: 'Merchant GoParrot' }),
    Expose({
        groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH],
    }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsString({ groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], MerchantDto.prototype, "title", void 0);
__decorate([
    ApiProperty({ type: () => String, minLength: 3, maxLength: 250, example: 'Merchant GoParrot Description' }),
    Expose({
        groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH],
    }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsString({ groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], MerchantDto.prototype, "subtitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50 }),
    Expose({
        groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH],
    }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsString({ groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], MerchantDto.prototype, "shortName", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50 }),
    Expose({
        groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH],
    }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsString({ groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    LengthWithLVS(3, 50, { groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    __metadata("design:type", String)
], MerchantDto.prototype, "name", void 0);
__decorate([
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ] }),
    IsEmpty({ always: true }),
    __metadata("design:type", String)
], MerchantDto.prototype, "type", void 0);
__decorate([
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ] }),
    __metadata("design:type", String)
], MerchantDto.prototype, "createdAt", void 0);
__decorate([
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ] }),
    __metadata("design:type", String)
], MerchantDto.prototype, "updatedAt", void 0);
__decorate([
    ApiPropertyOptional({ type: () => MerchantContactInfoDto }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsDefined({ groups: [MerchantExposeGroup.UPDATE] }),
    ValidateNested({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    Type(() => MerchantContactInfoDto),
    __metadata("design:type", MerchantContactInfoDto)
], MerchantDto.prototype, "contactInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => MerchantFeaturesFlagsDto }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    ValidateNested({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    Type(() => MerchantFeaturesFlagsDto),
    __metadata("design:type", MerchantFeaturesFlagsDto)
], MerchantDto.prototype, "featuresFlags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsObject({ always: true }),
    __metadata("design:type", Object)
], MerchantDto.prototype, "shortTermFeatureFlags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => MerchantMailerDto }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsDefined({ groups: [MerchantExposeGroup.UPDATE] }),
    ValidateNested({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    Type(() => MerchantMailerDto),
    __metadata("design:type", MerchantMailerDto)
], MerchantDto.prototype, "mailer", void 0);
__decorate([
    ApiPropertyOptional({ type: () => MerchantOrderDto }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsDefined({ groups: [MerchantExposeGroup.UPDATE] }),
    ValidateNested({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    Type(() => MerchantOrderDto),
    __metadata("design:type", MerchantOrderDto)
], MerchantDto.prototype, "order", void 0);
__decorate([
    ApiPropertyOptional({ type: () => MerchantPlacePickerDto }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsDefined({ groups: [MerchantExposeGroup.UPDATE] }),
    ValidateNested({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    Type(() => MerchantPlacePickerDto),
    __metadata("design:type", MerchantPlacePickerDto)
], MerchantDto.prototype, "placePicker", void 0);
__decorate([
    ApiProperty({ enum: StoreStateEnum, default: StoreStateEnum.ACTIVE }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ] }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], MerchantDto.prototype, "state", void 0);
__decorate([
    ApiProperty({ enum: StoreModeEnum, default: StoreModeEnum.REAL }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.CREATE] }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], MerchantDto.prototype, "mode", void 0);
__decorate([
    ApiProperty({ type: () => DictionaryDto }),
    Expose({
        groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.CREATE, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH],
    }),
    IsUndefinable({ groups: [MerchantExposeGroup.CREATE, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    ValidateNested({ always: true }),
    Type(() => DictionaryDto),
    __metadata("design:type", DictionaryDto)
], MerchantDto.prototype, "dictionary", void 0);
__decorate([
    ApiPropertyOptional({ type: () => MerchantCountryDto }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    IsOptional({ groups: [MerchantExposeGroup.PATCH] }),
    IsDefined({ groups: [MerchantExposeGroup.UPDATE] }),
    ValidateNested({ groups: [MerchantExposeGroup.UPDATE, MerchantExposeGroup.PATCH] }),
    Type(() => MerchantCountryDto),
    __metadata("design:type", MerchantCountryDto)
], MerchantDto.prototype, "country", void 0);
__decorate([
    ApiPropertyOptional({ enum: MerchantContractStatusEnum, default: MerchantContractStatusEnum.NOT_SIGNED }),
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ] }),
    IsUndefinable({ always: true }),
    IsEnum(MerchantContractStatusEnum, { always: true }),
    __metadata("design:type", String)
], MerchantDto.prototype, "contractStatus", void 0);
MerchantDto = __decorate([
    Expose({ groups: [MerchantExposeGroup.MODEL, MerchantExposeGroup.READ, MerchantExposeGroup.CREATE, MerchantExposeGroup.PATCH, MerchantExposeGroup.UPDATE] })
], MerchantDto);
export { MerchantDto };
//# sourceMappingURL=MerchantDto.js.map